import pluralize from 'pluralize';
import {
  parseISO,
  format,
  differenceInDays,
  startOfDay,
  endOfDay,
  addYears,
  subDays,
} from 'date-fns';
const FORMAT = 'dd/MM/y';
const getCoverDates = (startDate, endDate, isAnnual) => {
  if (!startDate) {
    return null;
  }
  const start = parseISO(startDate);
  const formattedStart = format(start, FORMAT);
  if (!isAnnual) {
    if (start && endDate) {
      const end = parseISO(endDate);
      const days = differenceInDays(endOfDay(end), startOfDay(start)) + 1; //  end.diff(start, 'days') + 1;

      return `${formattedStart} to ${format(end, FORMAT)} (${days} ${pluralize(
        'day',
        days,
      )})`;
    }
    return null;
  }
  const endDateForAnnual = subDays(addYears(start, 1), 1);

  return `${formattedStart} to ${format(endDateForAnnual, FORMAT)}`;
};
export default getCoverDates;
